export default {
  data: function data() {
    return {
      serverChannel: []
    };
  },
  activated: function activated() {},
  created: function created() {
    if (process.env.VUE_APP_COUNTTRY == "CN") {
      this.serverChannel = [{
        label: "taptap",
        value: "taptap"
      }, {
        label: "wegame",
        value: "wegame"
      }];

      if (process.env.VUE_APP_ENV == 'test') {
        this.serverChannel = [{
          label: "taptap",
          value: "taptap"
        }, {
          label: "wegame",
          value: "wegame"
        }, {
          label: "test",
          value: "test"
        }];
      }
    } else if (process.env.VUE_APP_COUNTTRY == "VN") {
      this.serverChannel = [{
        label: "vn",
        value: "vn"
      }];

      if (process.env.VUE_APP_ENV == 'test') {
        this.serverChannel = [{
          label: "vn",
          value: "vn"
        }, {
          label: "test",
          value: "test"
        }];
      }
    }
  },
  methods: {}
};